import { ActionButton } from '@/components/ActionButton';
import { ROUTES } from '@/config';
import { Typography } from '@/core/ui';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const RETURN_HOME_DELAY = 30 * 1000;

// A page load instead of a client-side navigation: it also recovers from what rendering again cannot fix,
// such as a lazy chunk that failed to download.
const returnHome = () => window.location.assign(ROUTES.HOME);

export const PageError = () => {
  const { t } = useTranslation('translation');

  // The kiosk is unattended most of the time, so it does not wait for somebody to press the button.
  useEffect(() => {
    const timeout = setTimeout(returnHome, RETURN_HOME_DELAY);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className='h-full w-full px-[192px] flex flex-col items-center justify-center gap-24 text-center'>
      <Typography className='uppercase tracking-widest text-[85px] leading-[100px]'>
        {t('error.title', { defaultValue: 'Ocorreu um erro' })}
      </Typography>
      <Typography className='text-[55px] leading-[66px]'>
        {t('error.description', { defaultValue: 'Não foi possível apresentar esta página.' })}
      </Typography>
      <ActionButton
        label={t('home.buttons.back')}
        variant='red'
        rounded='md'
        chevron='left'
        onClick={returnHome}
      />
    </div>
  );
};
